export const CURRENCY_TO_BITMAP_CHARACTERS: Record<string, number> = {
    PLN: 57344,
    EUR: 57345,
    NGN: 57346,
    CZK: 57347,
    RON: 57348,
    FUN: 57349,
    USD: 57350,
    CFA: 57351,
    ETB: 57352,
    GMD: 57353,
    KES: 57354,
    MWK: 57355,
    NAD: 57356,
    USX: 57357,
    ZMK: 57358,
    UGX: 57359,
    JMD: 57360,
    TTD: 57361,
    BBD: 57362,
    HTG: 57363,
    BWP: 57364,
    LSL: 57365,
    SZL: 57366
};
